import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ColumnResizer from "react-table-column-resizer";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import { sortItemSeq } from "utils/HelperFunction";
export function ProductTableSort(_param) {
    var columnsort = _param.columnsort, setColumnsort = _param.setColumnsort, columnoption = _param.columnoption, setCustomSort = _param.setCustomSort, setModal = _param.setModal, productRow = _param.productRow, setProductRow = _param.setProductRow, setFieldValue = _param.setFieldValue, fieldName = _param.fieldName, props = _object_without_properties(_param, [
        "columnsort",
        "setColumnsort",
        "columnoption",
        "setCustomSort",
        "setModal",
        "productRow",
        "setProductRow",
        "setFieldValue",
        "fieldName"
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-3",
        children: [
            /*#__PURE__*/ _jsxs("table", {
                className: "column_resize_table table1 table-striped ",
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    children: "ลำดับ"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "รายการแสดงผล"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 300
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("tbody", {
                        children: [
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            as: "select",
                                            name: "",
                                            onChange: function(e) {
                                                var newSort = columnoption.filter(function(item) {
                                                    return item.value === e.value;
                                                })[0];
                                                setColumnsort(function(prev) {
                                                    var updatedColumnsort = _to_consumable_array(prev.columnsort);
                                                    updatedColumnsort[0] = {
                                                        id: newSort.value,
                                                        sortKey: newSort.sortKey
                                                    };
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        columnsort: updatedColumnsort
                                                    });
                                                });
                                            },
                                            className: "w-100 select-st-1",
                                            options: columnoption,
                                            placeholder: "",
                                            value: columnoption.filter(function(item) {
                                                return item.value === columnsort.columnsort[0].id;
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            as: "select",
                                            name: "",
                                            onChange: function(e) {
                                                var newSort = columnoption.filter(function(item) {
                                                    return item.value === e.value;
                                                })[0];
                                                setColumnsort(function(prev) {
                                                    var updatedColumnsort = _to_consumable_array(prev.columnsort);
                                                    updatedColumnsort[1] = {
                                                        id: newSort.value,
                                                        sortKey: newSort.sortKey
                                                    };
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        columnsort: updatedColumnsort
                                                    });
                                                });
                                            },
                                            className: "w-100 select-st-1",
                                            options: columnoption,
                                            placeholder: "",
                                            value: columnoption.filter(function(item) {
                                                return item.value === columnsort.columnsort[1].id;
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            as: "select",
                                            name: "",
                                            onChange: function(e) {
                                                var newSort = columnoption.filter(function(item) {
                                                    return item.value === e.value;
                                                })[0];
                                                setColumnsort(function(prev) {
                                                    var updatedColumnsort = _to_consumable_array(prev.columnsort);
                                                    updatedColumnsort[2] = {
                                                        id: newSort.value,
                                                        sortKey: newSort.sortKey
                                                    };
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        columnsort: updatedColumnsort
                                                    });
                                                });
                                            },
                                            className: "w-100 select-st-1",
                                            options: columnoption,
                                            placeholder: "",
                                            value: columnoption.filter(function(item) {
                                                return item.value === columnsort.columnsort[2].id;
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center pb-4 pt-5 ",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-v2 me-auto",
                        onClick: function() {
                            setCustomSort(true);
                            setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        children: "จัดเรียงด้วยตนเอง"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-6 me-3 btn",
                        onClick: function() {
                            return setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-3 ",
                        onClick: function() {
                            var sorted = sortItemSeq(columnsort.columnsort, productRow);
                            setProductRow(sorted);
                            setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                            setFieldValue(fieldName, columnsort.columnsort.filter(function(v) {
                                return v.id;
                            }).map(function(v) {
                                return v.id;
                            }));
                        },
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    });
}
